module.exports = __webpack_public_path__ + "static/5-4230a889c0b0061b5488c0ff50438cd3.jpg";